import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/Addons/Index'

const AddOn = () => {
  return (
    <div className='page-main'>
        <Header name = {["Add On"]} />
        <Index />
    </div>
  )
}

export default AddOn